(function($) {
    if (!Modernizr.srcset){
        $.getScript('/inc/js/vendor/polyfills/picturefill.min.js')
    }
    if (!Modernizr.csspositionsticky){

    }
    if (!Modernizr.objectfit){
    }
})(jQuery);
